var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("head-info", {
        attrs: { nav: _vm.item.nav, banner: _vm.item.banner },
      }),
      _vm._v(" "),
      _c("film-item", { attrs: { list: _vm.item.filmList } }),
      _vm._v(" "),
      _c("hot-update-item", { attrs: { list: _vm.item.hotUpdate } }),
      _vm._v(" "),
      _c("hot-video-item", { attrs: { list: _vm.item.hotVideo } }),
      _vm._v(" "),
      _c("gotop"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }